<template>
    <div class="drop-zone-wrapper">
        <vue-dropzone id="dropzone"
                      ref="myVueDropzone"
                      :options="dropzoneOptions"
                      :use-custom-slot="true"
                      :duplicate-check="true"
                      @vdropzone-file-added="vfileAdded"
                      @vdropzone-success="vsuccess"
                      @vdropzone-complete="vcomplete"
                      @vdropzone-canceled="vcanceled"
                      @vdropzone-error="verror"
                      @vdropzone-removed-file="vremoved"
                      @vdropzone-sending="vsending"
                      @vdropzone-success-multiple="vsuccessMuliple"
                      @vdropzone-sending-multiple="vsendingMuliple"
                      @vdropzone-queue-complete="vqueueComplete"
                      @vdropzone-total-upload-progress="vprogress"
                      @vdropzone-upload-progress="vSingleProgress"
                      @vdropzone-mounted="vmounted"
                      @vdropzone-drop="vddrop"
                      @vdropzone-drag-start="vdstart"
                      @vdropzone-drag-end="vdend"
                      @vdropzone-drag-enter="vdenter"
                      @vdropzone-drag-over="vdover"
                      @vdropzone-drag-leave="vdleave"
                      @vdropzone-duplicate-file="vdduplicate"
                      @vdropzone-max-files-reached="vdmaxFilesReached"
        >
            <div class="drop-zone-placeholder">
                <svg class="drop-zone-placeholder__icon"
                     width="90"
                     height="90"
                >
                    <use xlink:href="#file-upload" />
                </svg>

                <svg class="drop-zone-placeholder__icon-uploaded drop-zone-placeholder__icon-uploaded--hidden"
                     width="90"
                     height="90"
                >
                    <use xlink:href="#file-upload-success" />
                </svg>

                <p class="drop-zone-placeholder__title">
                    {{ placeholderTitle }}
                </p>

                <div class="drop-zone-placeholder__text">
                    {{ $t('general.or') }}
                    <span v-t="'general.files.selectFile'"
                          class="drop-zone-placeholder__link"
                    />
                </div>
            </div>
        </vue-dropzone>
    </div>
</template>

<script>
import '@/assets/icons/file-upload.svg';
import '@/assets/icons/file-upload-success.svg';
import VueDropzone from 'vue2-dropzone';
import { $t } from '@/translations';

export default {
    components: {
        VueDropzone,
    },
    props: {
        dropzoneOptions: {
            type: Object,
            default: () => ({
                url: 'https://httpbin.org/post',
                thumbnailWidth: 150,
                maxFilesize: 2.0,
                headers: { 'My-Awesome-Header': 'header value' },
                addRemoveLinks: true,
            }),
        },
        placeholderTitle: {
            type: String,
            default: $t('items.bulk.dropTemplate'),
        },
    },
    data() {
        return {
            ok: true,
            fileAdded: false,
            filesAdded: false,
            success: false,
            error: false,
            removedFile: false,
            sending: false,
            successMultiple: false,
            sendingMultiple: false,
            queueComplete: false,
            uploadProgress: false,
            progress: false,
            myProgress: 0,
            isMounted: false,
            dDrop: false,
            dStarted: false,
            dEnded: false,
            dEntered: false,
            dOver: false,
            dLeave: false,
            dDuplicate: false,
            dmaxFilesReached: false,
            isDisabled: false,
        };
    },
    watch: {
        fileAdded() {
            const that = this;
            setTimeout(() => {
                that.fileAdded = false;
            }, 2000);
        },
        filesAdded() {
            const that = this;
            setTimeout(() => {
                that.filesAdded = false;
            }, 2000);
        },
        success() {
            const that = this;
            setTimeout(() => {
                that.success = false;
            }, 2000);
        },
        error() {
            const that = this;
            setTimeout(() => {
                that.error = false;
            }, 2000);
        },
        removedFile() {
            const that = this;
            setTimeout(() => {
                that.removedFile = false;
            }, 2000);
        },
        sending() {
            const that = this;
            setTimeout(() => {
                that.sending = false;
            }, 2000);
        },
        successMultiple() {
            const that = this;
            setTimeout(() => {
                that.successMultiple = false;
            }, 2000);
        },
        sendingMultiple() {
            const that = this;
            setTimeout(() => {
                that.sendingMultiple = false;
            }, 2000);
        },
        queueComplete() {
            const that = this;
            setTimeout(() => {
                that.queueComplete = false;
            }, 2000);
        },
        progress() {
            const that = this;
            setTimeout(() => {
                that.progress = false;
            }, 2000);
        },
        isMounted() {
            const that = this;
            setTimeout(() => {
                that.isMounted = false;
            }, 2000);
        },
        dDrop() {
            const that = this;
            setTimeout(() => {
                that.dDrop = false;
            }, 2000);
        },
        dStarted() {
            const that = this;
            setTimeout(() => {
                that.dStarted = false;
            }, 2000);
        },
        dEnded() {
            const that = this;
            setTimeout(() => {
                that.dEnded = false;
            }, 2000);
        },
        dEntered() {
            const that = this;
            setTimeout(() => {
                that.dEntered = false;
            }, 2000);
        },
        dOver() {
            const that = this;
            setTimeout(() => {
                that.dOver = false;
            }, 2000);
        },
        dLeave() {
            const that = this;
            setTimeout(() => {
                that.dLeave = false;
            }, 2000);
        },
        dDuplicate() {
            const that = this;
            setTimeout(() => {
                that.dDuplicate = false;
            }, 2000);
        },
    },
    mounted() {
        window.addEventListener('dragover', (e) => {
            e.preventDefault();
        }, false);
        window.addEventListener('drop', (e) => {
            e.preventDefault();
        }, false);
    },
    beforeDestroy() {
        window.removeEventListener('dragover', (e) => {
            e.preventDefault();
        }, false);
        window.removeEventListener('drop', (e) => {
            e.preventDefault();
        }, false);
    },
    methods: {
        vfileAdded(file) {
            this.$emit('file-added', file);

            this.addRemoveButton(file);
        },
        vfilesAdded(file) {
            this.$emit('files-added', file);
        },
        async vsuccess(file, response) {
            this.$emit('success', file, response);
        },
        vcomplete(file) {
            this.$emit('complete', file);
        },
        vcanceled(file) {
            this.$emit('canceled', file);
        },
        verror(file, message) {
            this.error = true;
            this.$emit('error', file, message);
        },
        vremoved(file, xhr, error) {
            this.$emit('removed', file, xhr, error);
        },
        vsending(file, xhr, formData) {
            this.sending = true;
            this.$emit('sending', file, xhr, formData);
        },
        vsuccessMuliple(files, response) {
            this.successMultiple = true;
            this.$emit('successMultiple', files, response);
        },
        vsendingMuliple(file, xhr, formData) {
            this.sendingMultiple = true;
            this.$emit('sendingMultiple', file, xhr, formData);
        },
        vqueueComplete(file, xhr, formData) {
            this.queueComplete = true;
            this.$emit('queueComplete', file, xhr, formData);
        },
        vprogress(totalProgress, totalBytes, totalBytesSent) {
            this.progress = true;
            this.myProgress = Math.floor(totalProgress);
            this.$emit('totalProgress', totalProgress, totalBytes, totalBytesSent);
        },
        vSingleProgress(file, progress, bytesSent) {
            this.$emit('progress', file, progress, bytesSent);

            if (progress === 100) {
                this.removeRemoveButton(file);
            }
        },
        vmounted() {
            this.isMounted = true;
        },
        vddrop() {
            this.dDrop = true;
        },
        vdstart() {
            this.dStarted = true;
        },
        vdend() {
            this.dEnded = true;
        },
        vdenter() {
            this.dEntered = true;
        },
        vdover() {
            this.dOver = true;
        },
        vdleave() {
            this.dLeave = true;
        },
        vdduplicate() {
            this.$emit('duplicate');
            this.dDuplicate = true;
        },
        vdmaxFilesReached() {
            this.dmaxFilesReached = true;
        },
        removeFile(file) {
            this.$refs.myVueDropzone.removeFile(file);
        },
        async removeAllFiles() {
            await this.$refs.myVueDropzone.removeAllFiles();
            await this.$refs.myVueDropzone.disable();
            await this.$nextTick();
            await this.$refs.myVueDropzone.enable();
        },
        addRemoveButton(file) {
            const fileUpload = document.querySelector('.dz-preview:not(.dz-remove-button-added)');

            if (fileUpload) {
                fileUpload.classList.add('dz-remove-button-added');

                const removeLink = document.createElement('A');
                const textNode = document.createTextNode($t('dropzone.cancelUpload'));
                removeLink.appendChild(textNode);
                removeLink.setAttribute('href', '#');
                removeLink.setAttribute('class', 'dz-remove');
                removeLink.setAttribute('id', `remove-${file.name}`);
                fileUpload.appendChild(removeLink);

                const thisReference = this;
                removeLink.addEventListener('click', () => {
                    thisReference.removeFile(file);
                }, false);
            }
        },
        removeRemoveButton(file) {
            const removeLink = document.getElementById(`remove-${file.name}`);
            removeLink.remove();
        },
    },
};
</script>

<style lang="scss" scoped>
@import 'dropZoneDefaults';

.drop-zone-wrapper {
    position: relative;
    width: 100%;
    margin: 20px;
}

.drop-zone-placeholder {
    $_this: &;

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 20px;
    background: none;
    text-align: center;
    cursor: pointer;

    &__icon {
        transition: $transition-quick;
        color: $color-separator;
    }

    &__icon-uploaded {
        display: block;
        margin: 20px auto;
        color: $color-teal-700;

        &--hidden {
            display: none;
        }
    }

    &__title {
        margin: .25em 0;
        color: $color-text-body;
        font-size: 15px;
        font-weight: 600;
        line-height: 28px;
    }

    &__text {
        color: $color-separator-dark;
        font-family: $font-family-primary;
        font-size: $font-size-base;
        font-weight: 400;
    }

    &__link {
        color: $color-link;
        text-decoration: underline;
    }

    &:hover,
    &:focus {
        #{$_this}__icon {
            color: $color-link;
        }
    }

    &:focus {
        @include input-box-focus();
    }

    &:hover {
        border-color: $color-button;
    }
}

::v-deep {
    .vue-dropzone {
        min-height: 240px;
        border: 2px dashed $color-select-options-border;
        border-radius: $input-border-radius;
    }

    .dropzone {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-around;
        padding: 0;

        .dz-message {
            width: 100%;
        }

        &.dz-clickable {
            * {
                cursor: pointer;
            }
        }

        &.dz-started {
            .dz-message {
                display: inline-block;
                order: 999;
                width: 250px;
                height: 250px;
                margin: 16px;
            }
        }

        &.dz-max-files-reached {
            .dz-message {
                display: none;
                cursor: default;
            }
        }

        .dz-preview {
            z-index: 0;
            overflow: hidden;

            .dz-image {
                z-index: 0;
                cursor: default;

                img:not([src]) {
                    width: 250px;
                    height: 250px;
                }
            }

            &.dz-file-preview {
                .dz-image {
                    background: none;
                }
            }

            .dz-details {
                z-index: 0;
                border: 2px dashed $color-select-options-border;
                border-radius: $input-border-radius;
                background-color: $color-white;
                color: $color-text-body;
                cursor: default;

                .dz-size {
                    display: none;
                }

                .dz-filename {
                    overflow: hidden;
                    font-family: $font-family-primary;
                    font-size: $font-size-md;
                    font-weight: 500;
                    text-align: center;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    cursor: default;

                    &:not(:hover) {
                        white-space: nowrap;
                    }

                    span {
                        cursor: default;
                    }
                }
            }

            .dz-progress {
                background: $color-gray-800;

                .dz-upload {
                    background: $color-teal-350;
                }
            }

            .dz-success-mark {
                svg {
                    path {
                        fill: $color-teal-350;
                    }
                }
            }

            .dz-error-message {
                display: block;
                z-index: 0;
                top: 60%;
                left: 0;
                width: 100%;
                margin-top: -20px;
                transform: translate(0, -60%);
                border-radius: 0;
            }

            &.dz-error {
                .dz-details {
                    border-color: $color-error;
                }

                .dz-error-mark {
                    animation: passing-through-data 3s;
                    opacity: 0;

                    svg {
                        path {
                            fill: $color-error;
                        }
                    }

                    @keyframes passing-through-data {
                        0% {
                            -webkit-transform: translateY(40px);
                            transform: translateY(40px);
                            opacity: 0;
                        }

                        30%,
                        70% {
                            -webkit-transform: translateY(0);
                            transform: translateY(0);
                            opacity: 1;
                        }

                        100% {
                            -webkit-transform: translateY(-40px);
                            transform: translateY(-40px);
                            opacity: 0;
                        }
                    }
                }

                .dz-error-message {
                    opacity: 1;
                }
            }

            .dz-remove {
                bottom: 5px;
                left: 50%;
                margin-left: 0;
                transform: translate(-50%, 0);
                border: none;
                opacity: 1;
                color: $color-teal-650;
                font-family: $font-family-primary;
                font-size: $font-size-base;
                font-weight: 400;
                letter-spacing: $letter-spacing-sm;
                text-transform: capitalize;

                &:hover {
                    color: $color-teal-350;
                }
            }
        }

        &.dz-drag-hover {
            border: 5px solid $color-teal-650;
            cursor: pointer;
        }
    }
}
</style>
